<template>
  <v-container fluid>
    <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
    <v-toolbar>
        <v-flex xs3>
          <v-layout row justify-start>
            <v-icon color="primary" @click="goBack">chevron_left</v-icon>
            <!-- <v-switch color="primary" @change="$store.state.tableView = !$store.state.tableView" hide-details></v-switch> -->
          </v-layout>
        </v-flex>
        <v-flex xs6 justify-center>
          <h2 class="text-xs-center">{{ lotNumber }}: {{ description }}</h2>
        </v-flex>
        <v-flex xs3>
          <v-layout row justify-end>
            <v-btn flat @click="createWorkOrder">NEW WO</v-btn>
            <v-icon @click="refresh">refresh</v-icon>
          </v-layout>
        </v-flex>
    </v-toolbar>
    <v-layout row>
      <v-flex xs12>
        <v-card v-if="tableView">
          <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
          </v-card-title>
        </v-card>
        <v-timeline search="search" v-if="!tableView">
          <v-timeline-item v-for="item in tableData"
            :key="item.id"
            :icon="item.icon"
            :color="item.color"
            large
            >
            <span slot="opposite">{{ item.date }}</span>
            <v-card :color="item.color" light hover>
              <!-- <v-card-title @click="rowClicked(item)">{{ item.type }} - {{ item.id }}</v-card-title> -->
              <v-card-title @click="rowClicked(item)">
                <v-layout row>
                  <h4>{{ item.type }}</h4>
                  <v-spacer></v-spacer>
                  <h4 v-if='item.type != "WT"'>{{ item.id }}</h4>
                  <h4 v-else>{{ item.tagId + 5000 }}</h4>
                </v-layout>
              </v-card-title>
              <v-card-text v-if="item.type == 'BLENDING'" @click="rowClicked(item)">
                <v-data-table dark
                   :headers='blendHeaders'
                   :items='item.BlendItems'
                   hide-actions>
                   <template slot="items" slot-scope="props">
                     <tr @click="blendClicked(props.item.description.lot)">
                       <td>{{ props.item.description.gallons }}</td>
                       <td>{{ props.item.description.direction }}</td>
                       <td>{{ props.item.description.lot }}</td>
                     </tr>
                   </template>
                </v-data-table>
              </v-card-text>
              <v-card-text v-if="item.finalDescription" @click="rowClicked(item)">{{ item.finalDescription }}</v-card-text>
            </v-card>
            </v-timeline-item>
        </v-timeline>
        <v-data-table v-if='tableView'
            :headers='headers'
            :items='tableData'
            :search='search'
            class="subheading font-weight-bold"
            hide-actions
            >
            <template slot="headerCell" slot-scope="props">
                <span class="subheading font-weight-medium"> {{ props.header.text }}</span>
            </template>
          <template slot="items" slot-scope="props">
            <tr @click="rowClicked(props.item)">
              <td width=150px>{{ props.item.date }}</td>
              <td width=100px v-if="isWT(props.item)">{{ props.item.tagId }} /{{ props.item.id }} </td>
              <td width=100px v-else>{{ props.item.id }}</td>
              <td width=125px>{{ props.item.type }}</td>
              <td>{{ props.item.finalDescription }}</td>
              <td width=50px class="text-xs-right" v-if="props.item.structure">{{ (props.item.structure.volume.total*1).toFixed(1) }}</td>
              <td width=100px>{{ props.item.structure.state }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
      </v-layout>
      <br>
      <v-layout row align-center justify-center wrap v-if="workOrders.length > 0">
        <v-flex lg12 class="text-xs-center">
          <v-card>LOT STRUCTURE ({{formattedNumber(workOrders[workOrders.length-1].structure.volume.total)}} -  GLNS)</v-card>
        </v-flex>
        <v-flex lg3 class="text-xs-center">
          <v-card>YEAR</v-card>
        </v-flex>
        <v-flex lg3 class="text-xs-center">
          <v-card>VARIETAL</v-card>
        </v-flex>
        <v-flex lg3 class="text-xs-center">
          <v-card>APPELLATION</v-card>
        </v-flex>
        <v-flex lg3 class="text-xs-center">
          <v-card>VINEYARD</v-card>
        </v-flex>
      </v-layout>
      <v-layout row align-center justify-center wrap v-if="workOrders.length > 0">
        <v-flex lg3 class="text-xs-center">
          <div v-for="item in workOrders[workOrders.length-1].structureTree[0].children" :key="item.id">
            <v-card>{{item.name}}</v-card>
          </div>
        </v-flex>
        <v-flex lg3 class="text-xs-center">
          <div v-for="item in workOrders[workOrders.length-1].structureTree[1].children" :key="item.id">
            <v-card>{{item.name}}</v-card>
          </div>
        </v-flex>
        <v-flex lg3 class="text-xs-center">
          <div v-for="item in workOrders[workOrders.length-1].structureTree[2].children" :key="item.id">
            <v-card>{{item.name}}</v-card>
          </div>
        </v-flex>
        <v-flex lg3 class="text-xs-center">
          <div v-for="item in workOrders[workOrders.length-1].structureTree[3].children" :key="item.id">
            <v-card>{{item.name}}</v-card>
          </div>
        </v-flex>
      </v-layout>
      <br>
      <v-layout row align-center justify-center wrap v-if="workOrders.length > 0">
        <v-flex lg12 class="text-xs-center">
          <v-card>INVENTORY ({{formattedNumber(workOrders[workOrders.length-1].structure.volume.total)}} -  GLNS)</v-card>
        </v-flex>
        <v-flex lg12>
          <v-data-table
            :headers='vesselHeaders'
              :items='vessels'
              class="subheading font-weight-bold"
              hide-actions
              >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.tank }}</td>
                <td>{{ props.item.bbls }}</td>
                <td>{{ props.item.topping }}</td>
                <td>{{ props.item.half_bbls }}</td>
                <td>{{ props.item.hogsHeads }}</td>
                <td>{{ props.item.puncheons.L_300 }}</td>
                <td>{{ props.item.puncheons.L_400 }}</td>
                <td>{{ props.item.puncheons.L_500 }}</td>
                <td>{{ props.item.puncheons.L_600 }}</td>
                <td>{{ props.item.ss_drums_55 }}</td>
                <td>{{ props.item.ss_drums_75 }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>

    </v-container>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import { clean } from '../utilities/clean'
import myMixins from '../mixins/myMixins'
export default {
  data () {
    return {
      search: '',
      loading: false,
      blendHeaders: [
        { text: 'GLNS', value: 'gallons' },
        { text: 'DIRECTION', value: 'direction' },
        { text: 'LOT', value: 'sourceLot' }
      ],
      headers: [
        { text: 'Date', value: 'date', sortable: false },
        { text: 'ID', value: 'id', sortable: false },
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Description', value: 'finalDescription', sortable: false },
        { text: 'Gallons', value: 'gallons', sortable: false },
        { text: 'State', value: 'state', sortable: false }
      ],
      tableData: [],
      vesselHeaders: [
        { text: 'TANK', value: 'tank', sortable: false },
        { text: 'BBLS', value: 'bbls', sortable: false },
        { text: 'TOPPING', value: 'topping', sortable: false },
        { text: 'HALF_BBLS', value: 'half_bbls', sortable: false },
        { text: 'HOGSHEADS', value: 'hogsHeads', sortable: false },
        { text: 'P-L-300', value: 'pl300', sortable: false },
        { text: 'P-L-400', value: 'pl400', sortable: false },
        { text: 'P-L-500', value: 'pl500', sortable: false },
        { text: 'P-L-600', value: 'pl600', sortable: false },
        { text: 'SS-DRUMS-55', value: 'drums55', sortable: false },
        { text: 'SS-DRUMS-75', value: 'drums75', sortable: false }
      ],
      vessels: [],
      workOrders: [],
      showPOPD: false,
      includePOPD: 0,
      total: 0,
      defaultPagination: 1,
      offset: 0,
      pageSize: 1000
    }
  },
  mixins: [myMixins],
  created () {
    this.updateTable(this.$route.params.lotNumber)
  },
  beforeRouteUpdate (to, from, next) {
    this.updateTable(to.params.lotNumber)
    next()
  },
  methods: {
    formattedNumber (value) {
      if (isNaN(value)) {
        return value
      } else {
        return Number.parseFloat(value).toFixed(1)
      }
    },
    refresh () {
      this.updateTable(this.$route.params.lotNumber)
    },
    displayTypeClicked (value) {
      this.displayType = value
    },
    isWT (value) {
      return (value.type === 'WT')
    },
    createWorkOrder () {
      this.$router.push({
        path: '/workorder/-1'
      })
    },
    blendClicked (lot) {
      console.log('blendclicked: ' +lot)
      this.$router.push({ path: `/workorders/${lot}` })
    },
    rowClicked (item) {
      if (item.type === 'BOL') {
        this.$router.push({
          path: '/bols/'+item.id
        })
        return
      }
      if (item.type === 'WT') {
        this.$router.push({
          path: '/weightag/'+item.id
        })
        return
      }
      this.$router.push({
        path: '/workorder',
        query: {
          id: item.id
        }
      })
    },
    updateTable (lot) {
      this.loading = true
      this.vessels = []
      axios
        .get(process.env.VUE_APP_BACKEND+'lots?lotNumber=' + lot)
        .then(response => {
          this.$store.state.lot = response.data.data[0]
          axios
            .get(process.env.VUE_APP_BACKEND+'workorders?limit=' + this.pageSize +
              '&offset=' +
              this.offset +
              '&lot=' +
              this.lotNumber +
              '&includePOPD=' +
              this.includePOPD)
            .then(response => {
              this.loading = false
              var $this = this
              this.workOrders = response.data.data
              if (this.workOrders.length > 0) {
                this.vessels.push(this.workOrders[this.workOrders.length-1].structure.volume)
              }
              this.tableData = response.data.data
              this.total = response.data.total
              this.tableData.finalDescription = this.tableData.otherDesc
              this.tableData.forEach(function (wo) {
                wo.date = moment(wo.date).format($this.$store.state.momentDateFormat)
                //                wo.finalDescription = utf8.decode(wo.otherDesc)
                wo.finalDescription = clean(wo.otherDesc)
                wo.color = $this.getColor(wo.type)
                wo.icon = $this.getIcon(wo.type)

                if (wo.type === 'SCP') {
                  wo.finalDescription = 'ESTIMATED TONS: ' + wo.SCPs[0].estimatedTons + ' ' + wo.SCPs[0].varietal
                }
                if (wo.type === 'BLENDING') {
                  wo.finalDescription = ''
                  wo.BlendItems.forEach(blend => {
                    wo.finalDescription += blend.description.gallons + ' GLNS ' + blend.description.direction + ' ' + blend.description.lot + '\r\n'
                  })
                }
                if (wo.type === 'LAB TEST') {
                  if (wo.LabTests) {
                    wo.LabTests.forEach(function (test) {
                      if (test.LabResults) {
                        test.LabResults.forEach(function (item) {
                          wo.finalDescription = item.labTest.toUpperCase() + ' ' + item.value1
                        })
                      }
                    })
                  }
                }
              })
            })
        })
    },
    includePOPDChanged (value) {
      this.includePOPD = 0
      if (value) {
        this.includePOPD = 1
      }
      this.updateTable()
    },
    pageChange (value) {
      this.offset = (value - 1) * this.pageSize
      this.updateTable()
    },
    filterHandler (value, row, column) {
      if (value === 'po' && row.type === 'PUMP OVER') return true
      if (value === 'lab' && row.type === 'LAB TEST') return true
      return false
    }
  },
  watch: {
    globalChange: function (nv, ov) {
      this.$router.push({
        path: '/lots'
      })
    }
  },
  computed: {
    tableView () {
      return this.$store.state.tableView
    },
    globalChange () {
      return JSON.stringify(this.$store.state.user) + JSON.stringify(this.$store.state.client) + this.$store.state.vintage
    },
    lotNumber () {
      return this.$store.state.lot.lotNumber
    },
    description: {
      get: function () {
        return this.$store.state.lot.description
      },
      set: function (value) {
        // this.$route.query.lot.description = value
      }
    }
  }
}
</script>
<style>
</style>
